﻿import { useEffect, useMemo, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import {
  api,
  type FaciliooMasterDataProbeResult,
  type FaciliooContractLiveResult,
  type FaciliooProcessResolveResult,
  type FaciliooSyncStatus,
  type ImportErrorRow,
  type ImportJobRow,
  type ImportType,
  type UiSettingsApi
} from "../app/api";
import { saveUiSettings, type UiSettings } from "../app/ui-settings";

const FACILIOO_SYNC_LOGO_DATA_URL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXUAAAF2CAYAAACRaQhmAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAABmJLR0QA/wD/AP+gvaeTAAAAB3RJTUUH5wwbFBwirUWrEAAAAAFvck5UAc+id5oAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMTItMjdUMjA6Mjg6MzQrMDA6MDDd54DfAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTEyLTI3VDIwOjI4OjM0KzAwOjAwrLo4YwAAAYdpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0n77u/JyBpZD0nVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkJz8+DQo8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIj48cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPjxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSJ1dWlkOmZhZjViZGQ1LWJhM2QtMTFkYS1hZDMxLWQzM2Q3NTE4MmYxYiIgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPjx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+PC9yZGY6RGVzY3JpcHRpb24+PC9yZGY6UkRGPjwveDp4bXBtZXRhPg0KPD94cGFja2V0IGVuZD0ndyc/PiyUmAsAACeESURBVHhe7d17lBxXfSfw7+/equ55j5E1LbNEjpPDy0AghEAWguPXTMvx4ZFssiEhsMsjQAix/JBlB2NjB0KwjY0tYbIEEvIi2SxhE86u17a6Zcx7wQRC7ACGQADbWaweyzAvzUxX3fvbP7pnPLoeWSNpuqfn1vdzTh1p6v5aXaqp++3q21W3ASIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiIiovhJuKJIavs/ccXo6Oi7pqamMhFJw/YOcAMDA3Z2bub8HePjt4eNRDGq7b/rvr6+8tMWFxcdABu2rytV19ffb+cXFu6pnnv2c8LmIjDhCiIi2rwY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBQRhjoRUUQY6kREEWGoExFFhKFORBSRQoe6qhpVRTcXrwrN1YbbQhStVfpB5xcv4WYURaFDvVQqzZbLZaRp2rWlXCrh5G1bfxhuC1Gs0lLJlUqlx/SFTiylUklLpRJKpVIWbkdRdPzVbF/9zqvCdRtNREySpLMHDvzgvMXF5niWZQ5AN86efZqm5sEHHvir+7///Xv7BgYG4L0PizaCivFQ3wfR775vz54Ph+3Uuy655LIX5XnzJQBmu3QcH5PTn/XMnX3l8tY8d77TJ5ICeGOtAfDQ9u3b3++9F2NMT3QzYwAR67z3Qwb2Y+PjZ34lrFkPHQ/1L37pyxqu22iqinK5jHvuuQe333abP+mkk4xzLizrCFXV4eFhKZVKUO2VXSNQ9SiXy5iamv7m+/be9PSwgnrXrl27rxkaHr56bm4OxlqgZ46rlunpaeR5riLS8bwxxmB+fl5PPfVUeenLXhY2b7g8z3HyySfj/vvvv6g6fs6esH09dHwn1+/8RBO69Exrfbqlg3K1+qV/bPkfPYLV2lvrvHdSKpX1O9/5tv3S3V8yg4ODXX0l9947AN17wqNQVRFBbm3S51z++b17bv75sIZ6165du3eLMdcvLi7OA0hFpKdSXUSSbgQ6Ws+FZrOJsbEx/fkXvzhH+yTu0Wdf+stqu2hl22p/XynMqKPXqaoAyAYHB/vnDh16Y/Xcsz8UFK+Ljr4VapEUIikgKYA1Lo9Xv7T+SO1h3WPXiZik/bPx3qPbS/st8irbtzGLiCRQpMYYQJGEv0HqecYYsxSe7WO7dxZVlbAPdHppB2iK1vG9SqasXLda22p/X7k83mNWr2v/bpIkSWBUO5a9HfuHiYio+xjqREQRYagTEUWEoU5EFBGGOhFRRBjqREQRYagTEUWEoU5EFBGGOhFRRBjqREQRYagTEUWEoU5EFBGGOhFRRBjqREQRYagTEUWEoU5EFBGGOhFRRBjqREQRYagTEUWEoU5EFBGGOhFRRBjqREQRYagTEUWEoU4tIgAkXEtE60i60MW6EOrqALhH/+yFZXmbfLi13aCqvrf2B5yqOlUPQFy4vdTzvKqu6Gs9t2i4wV2gS8+veqQMWvlz2Ha05VjqH61VhXPOQbVz+6Tjrxuf/fwXOrbxx0tVUSqVcN999+Ezn/60Dg0Nifddy3dNkkSMMWh1xF4gUPUol8uYm5u9d++em58dVlDv2rX78iv7+/reOTc3B2ttDx1XLXmeQ1sb1fG8ERE0m0095ZRT5Nzx8bB5w+V5ji0nn4yHfvDQBdXxs28J29dDx3dy/a67Wns2B5CErRsgBxZdnjxp2xMfue32W9908ODB1+V53pWtU1WfpqnJ8vwKA/9JACNOeuPM2HijIkic0x/ecstNd4ft1LsuvPDy04CF01Vt0xvf8T59rIzHh22SbM/z3ItIR0cHVNVba02SJA/sOP+811m12vRNY609/JWuKz2+bcVzqaoab0rNpt57/vlnPxiWroeeOwC66Y1vfPMlT9iy5cb5Q3MZRNKwvQNcqVSyWXPhzD179nw6bCSK0c4LL/5akiTPyPPcAbBh+7pSdUlasi7Pvr5nz03PDJuLoKOvmr2uf3BgQNV359OLFURkOFxHFCvVDgf5SiIAFGJM956zxxQ61J1zfiPerPTKkAtRtDr4QWSvK3Sob9R/Xn3vjXsSURw2KteIiKgDGOpERBFhqBMRRYShTkQUEYY6EVFEGOpERBFhqBMRRYShTkQUEYY6EVFEGOpERBFhqBMRRYShTkQUEYY6EVFEGOpERBFhqBMRRYShTkQUEYY6EVFEGOpERBFhqBMRRYShTkQUkUJ/AfLOnRdd0dc/8K6FhfkMQBq2d4ArlUp2oblw/i179tweNtLR5fvG3iIip0J0AdqVkxL1kHKu8oH+HQe+GzbS0V2w8+L70jR5Wp7nDoAN29eZS5LEeufvu/nmG08PG4uAoc5Q31Ty2th37SnJaZj1gO3C4esBDAjyhptIJxr7w2Y6OoZ6d3XjTIdoHclBHPRws37BTfms48usW8QjHtb4ZrglRL2IoU6bTYIEgEgqgo4vgKRIALhiv6ulzYOhTnQECig0XEvU2xjqREcgBf/MiTYnhjoRUUQY6kREEWGo0zL4XQTn5rXKb4fLqZgY6rQsl8s4//zz8eyzz4aNNm+4yP3nP/95DUP/l56hbvMN32Nno/zf17LeAqf4kS0fY73/K6yldSLqQ9x995jU83yJ7QfuwrCCelWnPmPUQ0TkrfPchKrup3vqOVx9qeoCF0GMjY29bceOH+lmQb3rP/7jP6KX34SOMdSN/r3M24D+K57v15aibvV9PbxxVR39R24RkZPnuQlt6/mWzP6fq2FQ0v77m/e7SC6Xw0UXXYRvfvOb+u4w5rIwur8A4M8eA3mbb6iXZowGwRYvYFVRrdwWf5ztq0N0vguvo/pqM0+ntfP89N98GfWYOv8GPjQ8fMcFnJ4e2S2j56K+JZ1Gvy9D26G5DKhXJ6I+hLrVQ+sV0K2CZG5U7iK26j4eXQcmvVfD/axfXaSqjn7QnUDF4ttwvV90+zqQ+6hWJ0PboXXK64uYtMImqu2fQJ+qo9Puq+m+Nvqn6uik+2q6o4fWKaBb8w57CGQvgYJ0EubQdmitAjpphQvYlq6WdIw9l53w9nWQ5znCHsXT9w+A8Wj7OLg4MS7jfdiWAjW0XgHdk1nxA8hA/7pd3OWLPqe7IeoNqb+yfY35PrpVnlvgrf1xWs+rNV0f/K9LYPw9fQjVqf9o+k58twqA+2oFyRczrv6Td8RCoGNQvsxn+mGtv9dNvxD2CeXKQ4wJqN4D1xMUS/pd9Yluu7/Y3SM9zmyL/M4no+fC84A04Y8AqsL7DFBBygUrG9C9Y+0J2w1Q/9X9/dvPG/Gf7xYz6fnY+PjfvyCsXa+ALsb0F5V2RO2/3f/Pv9a57vst36dP1fE7hPUeXK+AbmUEh8QqoM+1J7KY0Y4+9PtK2zB4jyHnCj+I8U3fAZ1/h5QlkbBp5cmQ/ALW8Iu8R+1JYBqO+Y8M0UHd1Q2QRVA7Mprj/P0Cf+v5Q9/OYNXXjLUhRGvWrbRGIGdQnUaR6xzWf0hNXmM8Y4P2hQp4L3N6+W9B15bT5hIouY0QHkD1Anr3VfR5t7bNdhX+9K9f4fqLF5bByZ9DN0n7fXK+1wx5ELQz2j7mSpVfW12lR3i+L2aX8wTudxD8mWen6mZJxf7m7r3AywY8Q5+UANw9dyq/8t6mLe8FYE0lJq3w1zGfZQ3V6v8JYFQHk/Up+6p/4jrR+8h7ZfQ6tPq9KQfbv8xkE9RLmQ5e2m8Kq1y7dp6p+2x1kY+5T1q+0R7J6Nedx6f95l20p8dKac9l7H6g+e7F6a6mQyWf1nvaPfM7y+2Z4PVkN0kHq2rX7kQ5Q+f2aN1fAqg9n48KJ8FjXqFfOnV+2+6sWwPj8f3/7t1v53r2nvl3v9u/t4r9d3N5N/udx+Vf7n8HqHj2M2gP8f7V2nfp5b8lR3F8mX3f8b0rD6l9xVq9Qf2vLJxgH1l3f2K4n3q9p0z0t+Yh+UAA2k3Tg4A2n+0QH5mYf3nf9S4zQ3A8w0qv+n3cG8m2D6m9m2u8f8H9wM4z3M4v+5h4sX5QeXQG3xqg2n9L8Yf5q5x2dB9n2M9Qn9y3Ww0g7gQ7z8Y9z8Qw6tV1Xv7s6e1x6hX2vG0fA7f7x6d4qf6kL1u5y3qv+R9Kf4R7xP1h2iT2k3QqgA7v2x3mV9zH4jVbH8mQ7hO8f5d7v8+E0i+6n8jv3a6y2n7m7v4x9t2f8n6u7w7N3o9n+vX/3QmCjV7y6A1Y3Nn1f6n0Q0m6v9+qQG0x8n1z4mH5j3V8v1f6w6o7qv9x8j3b3k8j6o9m8s7+v3l9S8i8n8x8m7b5x7p3m9m+R3m8x8q7r5n8i8w9a8k7h5f6g5d5f5c5b5a5Z5Y5X5W5V5U5T5S5R5Q5P5O5N5M5L5K5J5I5H5G5F5E5D5C5B5A5/58wJ6JQ3sH1rJwAAAABJRU5ErkJggg==";

const REQUIRED_FIELDS: Record<ImportType, string[]> = {
  objects: ["objektnummer", "objektname", "strasse", "plz", "ort", "status"],
  units: ["objektnummer", "einheitsnummer", "einheitstyp", "mea", "status"],
  owners: ["objektnummer", "eigentuemer_id", "name_1", "status"],
  assignments: ["objektnummer", "einheitsnummer", "eigentuemer_id", "status"]
};

const importLabel = (value: ImportType) => {
  if (value === "objects") return "Objekte";
  if (value === "units") return "Einheiten";
  if (value === "owners") return "Eigentümer";
  return "Zuordnungen";
};

const IMPORT_FIELD_LABELS: Record<string, string> = {
  objektnummer: "Objektnummer",
  objektname: "Objektname",
  strasse: "Strasse",
  plz: "PLZ",
  ort: "Ort",
  status: "Status",
  einheitsnummer: "Einheitsnummer",
  einheitstyp: "Einheitstyp",
  mea: "MEA",
  eigentuemer_id: "Eigentümer-ID",
  name_1: "Name 1"
};

const importFieldLabel = (field: string) => IMPORT_FIELD_LABELS[field] ?? field;

const extractCsvHeaders = (content: string) => {
  const firstLine = content
    .split(/\r?\n/)
    .map((line) => line.trim())
    .find((line) => line.length > 0);
  if (!firstLine) return [];
  const commaCount = (firstLine.match(/,/g) ?? []).length;
  const semicolonCount = (firstLine.match(/;/g) ?? []).length;
  const separator = semicolonCount > commaCount ? ";" : ",";
  return firstLine
    .split(separator)
    .map((entry) => entry.trim().replace(/^"(.*)"$/, "$1"))
    .filter(Boolean);
};

const normalizeMappingKey = (value: string) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");

const createSuggestedMapping = (requiredFields: string[], sourceColumns: string[]) => {
  const normalizedColumnMap = new Map<string, string>();
  sourceColumns.forEach((column) => {
    const key = normalizeMappingKey(column);
    if (!key) return;
    if (!normalizedColumnMap.has(key)) normalizedColumnMap.set(key, column);
  });
  return requiredFields.reduce<Record<string, string>>((acc, field) => {
    const exact = normalizedColumnMap.get(normalizeMappingKey(field));
    acc[field] = exact ?? "";
    return acc;
  }, {});
};

const FACILIOO_LIVE_SYNC_INTERVAL_MINUTES = 24 * 60;
const FACILIOO_LIVE_SYNC_SCHEDULE_LABEL = "taeglich um 02:00";

const statusLabel = (value: ImportJobRow["status"]) => {
  if (value === "uploaded") return "Hochgeladen";
  if (value === "validated") return "Validiert";
  if (value === "failed") return "Fehlerhaft";
  return "Importiert";
};

const statusBadgeClass = (value: ImportJobRow["status"]) => {
  if (value === "uploaded") return "badge import-uploaded";
  if (value === "validated") return "badge import-validated";
  if (value === "failed") return "badge import-failed";
  return "badge import-imported";
};

const FACILIOO_DATASET_ORDER = [
  { key: "objects", label: "Objekte", className: "is-objects" },
  { key: "units", label: "Einheiten", className: "is-units" },
  { key: "assignments", label: "Zuordnungen", className: "is-assignments" },
  { key: "owners", label: "Eigentümer", className: "is-owners" }
] as const;

const formatDateTimeDE = (value?: string | null) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "-";
  return parsed.toLocaleString("de-DE");
};

const formatDurationLabel = (durationMs?: number) => {
  if (typeof durationMs !== "number" || !Number.isFinite(durationMs) || durationMs <= 0) return "-";
  const totalSeconds = Math.max(1, Math.round(durationMs / 1000));
  if (totalSeconds < 60) return `${totalSeconds}s`;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
};

const toGermanValidationReason = (rawMessage: string) => {
  const message = String(rawMessage ?? "").trim();
  if (!message) {
    return "Validierung derzeit nicht möglich. Bitte später erneut versuchen.";
  }
  if (/502|bad gateway|gateway/i.test(message)) {
    return "Validierung derzeit nicht möglich, weil der Server nicht erreichbar ist (Gateway-Fehler). Bitte später erneut versuchen.";
  }
  if (/failed to fetch|networkerror|netzwerk|connection|econn|timeout|timed out/i.test(message)) {
    return "Validierung derzeit nicht möglich, weil keine stabile Verbindung zum Server besteht. Bitte Verbindung prüfen und erneut versuchen.";
  }
  if (/importjob nicht gefunden/i.test(message)) {
    return "Validierung nicht möglich: Der Importjob wurde nicht gefunden. Bitte Datei erneut hochladen.";
  }
  if (/mapping|spaltenzuordnung|ungueltig|ungültig/i.test(message)) {
    return "Validierung nicht möglich: Die Spaltenzuordnung ist unvollständig oder ungültig. Bitte Zuordnung prüfen.";
  }
  return `Validierung derzeit nicht möglich: ${message}`;
};

const renderImportsMenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 5.3v8.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="m8.8 11 3.2 3.2 3.2-3.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="4.8" y="15.8" width="14.4" height="3.8" rx="1.4" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const renderDatasetSymbol = (key: (typeof FACILIOO_DATASET_ORDER)[number]["key"]) => {
  if (key === "objects") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M4.9 8.2h14.2v10.9H4.9z" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (key === "units") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <rect x="5.1" y="4.8" width="13.8" height="14.8" rx="2.1" stroke="currentColor" strokeWidth="1.85" />
        <path d="M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" />
        <path d="M9.2 19.6v-2.9h5.6v2.9" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (key === "assignments") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <circle cx="6.2" cy="7.2" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.8" cy="16.8" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.8" cy="7.2" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.4 7.2h7.2M7.9 8.8l7.4 6.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <circle cx="9.1" cy="9.1" r="2.5" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="15.8" cy="8.4" r="2.1" stroke="currentColor" strokeWidth="1.8" />
      <path d="M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
};

const renderManualImportTypeIcon = (type: ImportType) => {
  if (type === "objects") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4.9 8.2h14.2v10.9H4.9z" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8.1 4.9h7.8v3.3H8.1zM8.2 12h2.6M13.2 12h2.6M8.2 15.4h2.6M13.2 15.4h2.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (type === "units") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5.1" y="4.8" width="13.8" height="14.8" rx="2.1" stroke="currentColor" strokeWidth="1.85" />
        <path d="M8.3 9h2.6M13.1 9h2.6M8.3 13.2h2.6M13.1 13.2h2.6" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" />
        <path d="M9.2 19.6v-2.9h5.6v2.9" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (type === "owners") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="9.1" cy="9.1" r="2.5" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="15.8" cy="8.4" r="2.1" stroke="currentColor" strokeWidth="1.8" />
        <path d="M4.7 18.6a5 5 0 0 1 8.8 0M12.2 18.6a4.2 4.2 0 0 1 7.1 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="6.2" cy="7.2" r="2.1" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.8" cy="16.8" r="2.1" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="17.8" cy="7.2" r="2.1" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8.4 7.2h7.2M7.9 8.8l7.4 6.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
};

export const ImportsPage = () => {
  const qc = useQueryClient();
  const isFrameworkV2 =
    typeof document !== "undefined" && document.body.classList.contains("framework-v2");
  const [importMode, setImportMode] = useState<"manual" | "facilioo">("facilioo");
  const [manualImportType, setManualImportType] = useState<ImportType>("objects");
  const [file, setFile] = useState<File | null>(null);
  const [job, setJob] = useState<ImportJobRow | null>(null);
  const [mapping, setMapping] = useState<Record<string, string>>({});
  const [validationErrors, setValidationErrors] = useState<ImportErrorRow[]>([]);
  const [confirmedWarnings, setConfirmedWarnings] = useState<Record<string, boolean>>({});
  const [actionError, setActionError] = useState("");
  const [faciliooTestStatus, setFaciliooTestStatus] = useState<{ type: "ok" | "error"; text: string } | null>(null);
  const [faciliooTestPending, setFaciliooTestPending] = useState(false);
  const [faciliooMasterDataProbePending, setFaciliooMasterDataProbePending] = useState(false);
  const [faciliooMasterDataProbe, setFaciliooMasterDataProbe] = useState<FaciliooMasterDataProbeResult | null>(null);
  const [faciliooMasterDataProbeError, setFaciliooMasterDataProbeError] = useState<string | null>(null);
  const [faciliooSyncStatusMessage, setFaciliooSyncStatusMessage] = useState<{
    type: "ok" | "error" | "info";
    text: string;
  } | null>(null);
  const [faciliooSyncSnapshot, setFaciliooSyncSnapshot] = useState<FaciliooSyncStatus | null>(null);
  const [faciliooSyncPending, setFaciliooSyncPending] = useState(false);
  const [faciliooSyncRunning, setFaciliooSyncRunning] = useState(false);
  const [faciliooSyncCancelPending, setFaciliooSyncCancelPending] = useState(false);
  const [faciliooTestObjectNumber, setFaciliooTestObjectNumber] = useState("");
  const [faciliooDebugAccountId, setFaciliooDebugAccountId] = useState("");
  const [faciliooDebugContractId, setFaciliooDebugContractId] = useState("");
  const [faciliooDebugProcessRef, setFaciliooDebugProcessRef] = useState("");
  const [faciliooProcessFeedTestEnabled, setFaciliooProcessFeedTestEnabled] = useState(false);
  const [faciliooProcessFeedTestText, setFaciliooProcessFeedTestText] = useState("");
  const [faciliooContractTestPending, setFaciliooContractTestPending] = useState(false);
  const [faciliooContractTestResult, setFaciliooContractTestResult] = useState<FaciliooContractLiveResult | null>(null);
  const [faciliooContractTestError, setFaciliooContractTestError] = useState<string | null>(null);
  const [faciliooProcessTestPending, setFaciliooProcessTestPending] = useState(false);
  const [faciliooProcessTestResult, setFaciliooProcessTestResult] = useState<FaciliooProcessResolveResult | null>(null);
  const [faciliooProcessTestError, setFaciliooProcessTestError] = useState<string | null>(null);
  const [faciliooLiveSyncEnabled, setFaciliooLiveSyncEnabled] = useState(false);
  const [faciliooControlStatus, setFaciliooControlStatus] = useState<{ type: "ok" | "error"; text: string } | null>(null);
  const [faciliooControlPending, setFaciliooControlPending] = useState(false);
  const [faciliooMirrorCleanupPending, setFaciliooMirrorCleanupPending] = useState(false);
  const [faciliooMirrorCleanupStatus, setFaciliooMirrorCleanupStatus] = useState<{ type: "ok" | "error"; text: string } | null>(null);
  const [manualFileDragActive, setManualFileDragActive] = useState(false);
  const [manualSourceColumns, setManualSourceColumns] = useState<string[]>([]);
  const [validationFeedback, setValidationFeedback] = useState<{
    type: "error" | "warn" | "success";
    text: string;
  } | null>(null);
  const manualFileInputRef = useRef<HTMLInputElement | null>(null);
  const manualImportTypes: ImportType[] =
    importMode === "facilioo" ? ["objects", "units", "owners"] : ["objects", "units", "owners", "assignments"];
  const manualFileInputId = "manual-import-file";

  const { data: uiSettings } = useQuery({
    queryKey: ["ui-settings-facilioo-controls"],
    queryFn: () => api.uiSettings()
  });
  const faciliooEnabled = uiSettings?.management?.faciliooEnabled !== false;
  const { data: latestFaciliooSyncLog } = useQuery({
    queryKey: ["imports-facilioo-latest-actor"],
    queryFn: () => api.faciliooSyncLogs({ page: 1, pageSize: 1 }),
    enabled: faciliooEnabled
  });

  useEffect(() => {
    if (!uiSettings) return;
    if (!faciliooEnabled) {
      setImportMode("manual");
    } else {
      setImportMode(uiSettings.management.faciliooDataConnectionMode === "manual" ? "manual" : "facilioo");
    }
    setFaciliooLiveSyncEnabled(Boolean(uiSettings.management.faciliooLiveSyncEnabled));
  }, [faciliooEnabled, uiSettings]);

  const initializeMapping = (type: ImportType, sourceColumns: string[] = []) => {
    const required = REQUIRED_FIELDS[type];
    if (sourceColumns.length > 0) {
      setMapping(createSuggestedMapping(required, sourceColumns));
      return;
    }
    const initial = required.reduce<Record<string, string>>((acc, field) => {
      acc[field] = field;
      return acc;
    }, {});
    setMapping(initial);
  };

  const uploadMutation = useMutation({
    mutationFn: () => {
      if (!file) throw new Error("Bitte eine Datei auswählen.");
      return api.uploadImportFile(manualImportType, file);
    },
    onSuccess: async (uploaded) => {
      setActionError("");
      setValidationFeedback(null);
      setJob(uploaded);
      initializeMapping(manualImportType, manualSourceColumns);
      setValidationErrors([]);
      setConfirmedWarnings({});
      await qc.invalidateQueries({ queryKey: ["imports"] });
    },
    onError: (error) => setActionError(error instanceof Error ? error.message : "Upload fehlgeschlagen")
  });

  const validateMutation = useMutation({
    mutationFn: () => {
      if (!job) throw new Error("Kein Importjob vorhanden.");
      return api.validateImport(job.id, mapping);
    },
    onSuccess: async (result) => {
      setValidationErrors(result.errors);
      setConfirmedWarnings({});
      const blockingErrors = result.errors.filter((entry) => !entry.overridable).length;
      if (blockingErrors > 0) {
        setValidationFeedback({
          type: "error",
          text: `Validierung nicht möglich: ${blockingErrors} Fehler blockieren den Import. Bitte Fehlerliste prüfen.`
        });
      } else if (result.errors.length > 0) {
        setValidationFeedback({
          type: "warn",
          text: `Validierung mit Hinweisen: ${result.errors.length} Hinweis(e). Bitte prüfen und ggf. bestätigen.`
        });
      } else {
        setValidationFeedback({
          type: "success",
          text: "Validierung erfolgreich. Import kann final ausgeführt werden."
        });
      }
      setActionError("");
      const fresh = await api.importById(result.jobId);
      setJob(fresh);
      await qc.invalidateQueries({ queryKey: ["imports"] });
    },
    onError: (error) => {
      const raw = error instanceof Error ? error.message : "";
      setValidationFeedback({
        type: "error",
        text: toGermanValidationReason(raw)
      });
      setActionError("");
    }
  });

  const commitMutation = useMutation({
    mutationFn: () => {
      if (!job) throw new Error("Kein Importjob vorhanden.");
      const confirmedErrorIds = validationErrors.filter((error) => error.overridable && confirmedWarnings[error.id]).map((error) => error.id);
      return api.commitImport(job.id, confirmedErrorIds);
    },
    onSuccess: async () => {
      setActionError("");
      if (job) {
        const fresh = await api.importById(job.id);
        setJob(fresh);
      }
      await qc.invalidateQueries({ queryKey: ["imports"] });
      await qc.invalidateQueries({ queryKey: ["objects"] });
      await qc.invalidateQueries({ queryKey: ["units"] });
      await qc.invalidateQueries({ queryKey: ["owners"] });
      await qc.invalidateQueries({ queryKey: ["assignments"] });
    },
    onError: (error) => setActionError(error instanceof Error ? error.message : "Import fehlgeschlagen")
  });

  const requiredFields = REQUIRED_FIELDS[manualImportType];
  const mappingOptions = useMemo(() => {
    if (manualSourceColumns.length > 0) {
      return Array.from(
        new Set(
          manualSourceColumns
            .map((column) => String(column ?? "").trim())
            .filter(Boolean)
        )
      );
    }

    // Fallback (z.B. XLSX ohne lokale Header-Erkennung im Frontend).
    const values = new Set<string>(requiredFields);
    requiredFields.forEach((field) => {
      const mappedColumn = String(mapping[field] ?? "").trim();
      if (mappedColumn) values.add(mappedColumn);
    });
    return Array.from(values);
  }, [requiredFields, manualSourceColumns, mapping]);
  const canUpload = Boolean(file) && !uploadMutation.isPending;
  const mappedRequiredColumns = requiredFields
    .map((field) => String(mapping[field] ?? "").trim())
    .filter(Boolean);
  const missingRequiredMappings = requiredFields.filter((field) => !String(mapping[field] ?? "").trim());
  const duplicateRequiredMappings = Array.from(
    mappedRequiredColumns.reduce<Map<string, number>>((acc, value) => {
      acc.set(value, (acc.get(value) ?? 0) + 1);
      return acc;
    }, new Map<string, number>())
  )
    .filter(([, count]) => count > 1)
    .map(([column]) => column);
  const hasMappingConflict = missingRequiredMappings.length > 0 || duplicateRequiredMappings.length > 0;
  const mappingConflictText = missingRequiredMappings.length > 0
    ? `Bitte Pflichtfelder zuordnen: ${missingRequiredMappings.map(importFieldLabel).join(", ")}.`
    : duplicateRequiredMappings.length > 0
      ? `Bitte Mehrfachzuordnung korrigieren (gleiche Quellspalte mehrfach): ${duplicateRequiredMappings.join(", ")}.`
      : "";
  const canValidate = Boolean(job) && !validateMutation.isPending && !commitMutation.isPending && !hasMappingConflict;
  const pendingWarningConfirmations = validationErrors.filter((error) => error.overridable && !confirmedWarnings[error.id]);
  const hasBlockingErrors = validationErrors.some((error) => !error.overridable);
  const canCommit = Boolean(job && job.status === "validated" && Number(job.invalid_rows ?? 0) === 0) && !commitMutation.isPending && !hasBlockingErrors && pendingWarningConfirmations.length === 0;

  const validationSummary = useMemo(() => {
    if (!job) return null;
    return `Gesamt: ${job.total_rows} | Valide: ${job.valid_rows} | Fehler: ${job.invalid_rows}`;
  }, [job]);

  const handleManualFileSelect = (fileList?: FileList | null) => {
    if (!fileList || fileList.length === 0) return;
    setFile(fileList[0] ?? null);
  };

  const handleDownloadManualFile = () => {
    if (!file) return;
    const url = URL.createObjectURL(file);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = file.name || "import-datei";
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    let cancelled = false;
    const syncSourceColumns = async () => {
      if (!file) {
        setManualSourceColumns([]);
        return;
      }
      const lowerName = file.name.toLowerCase();
      const isCsv = lowerName.endsWith(".csv") || file.type === "text/csv";
      if (!isCsv) {
        setManualSourceColumns([]);
        return;
      }
      try {
        const text = await file.text();
        if (cancelled) return;
        setManualSourceColumns(extractCsvHeaders(text));
      } catch {
        if (!cancelled) setManualSourceColumns([]);
      }
    };
    syncSourceColumns();
    return () => {
      cancelled = true;
    };
  }, [file]);

  useEffect(() => {
    if (!file) return;
    if (manualSourceColumns.length === 0) return;
    setMapping(createSuggestedMapping(REQUIRED_FIELDS[manualImportType], manualSourceColumns));
    setValidationFeedback(null);
  }, [file, manualImportType, manualSourceColumns]);

  const refreshFaciliooSyncStatus = async () => {
    try {
      const status = await api.getFaciliooSyncStatus();
      setFaciliooSyncSnapshot(status);
      const syncIsRunning = Boolean(status.running || status.webhookRun?.running);
      setFaciliooSyncRunning(syncIsRunning);
      if (!syncIsRunning) {
        setFaciliooSyncPending(false);
        setFaciliooSyncCancelPending(false);
      }
      if (status.running && status.currentRun) {
        setFaciliooSyncStatusMessage(null);
        return;
      }
      if (!status.lastRun?.finishedAt) {
        setFaciliooSyncStatusMessage({
          type: "info",
          text: `Live-Sync ${status.enabled ? "aktiv" : "inaktiv"} (${FACILIOO_LIVE_SYNC_SCHEDULE_LABEL}). Noch kein Lauf.`
        });
        return;
      }
      setFaciliooSyncStatusMessage(null);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Sync-Status konnte nicht geladen werden";
      setFaciliooSyncStatusMessage({ type: "error", text: message });
    }
  };

  useEffect(() => {
    void refreshFaciliooSyncStatus();
  }, []);

  useEffect(() => {
    if (!faciliooSyncRunning && !faciliooSyncPending) return;
    const timer = window.setInterval(() => {
      void refreshFaciliooSyncStatus();
    }, 5000);
    return () => window.clearInterval(timer);
  }, [faciliooSyncRunning, faciliooSyncPending]);

  const runFaciliooTest = async () => {
    setFaciliooTestPending(true);
    setFaciliooTestStatus(null);
    try {
      const result = await api.testFaciliooConnection();
      setFaciliooTestStatus({
        type: "ok",
        text: `Verbindung erfolgreich. /my-requests erreichbar (${result.total} Einträge).`
      });
    } catch (error) {
      const message = error instanceof Error ? error.message : "Facilioo-Test fehlgeschlagen";
      setFaciliooTestStatus({ type: "error", text: message });
    } finally {
      setFaciliooTestPending(false);
    }
  };

  const runFaciliooMasterDataProbe = async () => {
    setFaciliooMasterDataProbePending(true);
    setFaciliooMasterDataProbeError(null);
    try {
      const result = await api.probeFaciliooMasterData();
      setFaciliooMasterDataProbe(result);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Master-Data-Probe fehlgeschlagen";
      setFaciliooMasterDataProbeError(message);
      setFaciliooMasterDataProbe(null);
    } finally {
      setFaciliooMasterDataProbePending(false);
    }
  };

  const runFaciliooFullSyncNow = async () => {
    setFaciliooSyncPending(true);
    void refreshFaciliooSyncStatus();
    try {
      const result = await api.runFaciliooSyncNow(undefined, undefined, "full");
      setFaciliooSyncStatusMessage({
        type: "ok",
        text: result.message || "Facilioo Voll-Sync gestartet."
      });
      await refreshFaciliooSyncStatus();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Voll-Sync fehlgeschlagen";
      setFaciliooSyncStatusMessage({ type: "error", text: message });
    } finally {
      setFaciliooSyncPending(false);
    }
  };

  const runFaciliooLiveUpdateNow = async () => {
    setFaciliooSyncPending(true);
    void refreshFaciliooSyncStatus();
    try {
      const result = await api.runFaciliooSyncNow(undefined, undefined, "live_update");
      setFaciliooSyncStatusMessage({
        type: "ok",
        text: result.message || "Facilioo Live-Update gestartet."
      });
      await refreshFaciliooSyncStatus();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Live-Update fehlgeschlagen";
      setFaciliooSyncStatusMessage({ type: "error", text: message });
    } finally {
      setFaciliooSyncPending(false);
    }
  };

  const runFaciliooObjectSyncNow = async () => {
    const objectNumber = faciliooTestObjectNumber.trim();
    if (!objectNumber) {
      setFaciliooSyncStatusMessage({ type: "error", text: "Bitte eine Objektnummer für den Testlauf eingeben." });
      return;
    }
    setFaciliooSyncPending(true);
    void refreshFaciliooSyncStatus();
    try {
      const result = await api.runFaciliooSyncNow(objectNumber, undefined, "full");
      setFaciliooSyncStatusMessage({
        type: "ok",
        text: result.message || "Test-Synchronisierung gestartet."
      });
      await refreshFaciliooSyncStatus();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Objekt-Synchronisierung fehlgeschlagen";
      setFaciliooSyncStatusMessage({ type: "error", text: message });
    } finally {
      setFaciliooSyncPending(false);
    }
  };

  const runFaciliooContactDebugSyncNow = async () => {
    const accountId = faciliooDebugAccountId.trim();
    if (!accountId) {
      setFaciliooSyncStatusMessage({ type: "error", text: "Bitte eine Debug-Account-ID eingeben." });
      return;
    }
    setFaciliooSyncPending(true);
    void refreshFaciliooSyncStatus();
    try {
      const result = await api.runFaciliooSyncNow(undefined, accountId, "full");
      setFaciliooSyncStatusMessage({
        type: "ok",
        text: result.message || "Kontakt-Debug-Synchronisierung gestartet."
      });
      await refreshFaciliooSyncStatus();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Kontakt-Debug fehlgeschlagen";
      setFaciliooSyncStatusMessage({ type: "error", text: message });
    } finally {
      setFaciliooSyncPending(false);
    }
  };

  const cancelFaciliooSyncNow = async () => {
    setFaciliooSyncCancelPending(true);
    try {
      const result = await api.cancelFaciliooSync();
      setFaciliooSyncStatusMessage({
        type: "ok",
        text: result.message || "Abbruch wurde angefordert."
      });
      await refreshFaciliooSyncStatus();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Abbruch konnte nicht angefordert werden";
      setFaciliooSyncStatusMessage({ type: "error", text: message });
    } finally {
      setFaciliooSyncCancelPending(false);
    }
  };

  const runFaciliooContractDebug = async () => {
    const contractId = faciliooDebugContractId.trim();
    if (!contractId) {
      setFaciliooContractTestError("Bitte eine Contract-ID eingeben.");
      setFaciliooContractTestResult(null);
      return;
    }
    setFaciliooContractTestPending(true);
    setFaciliooContractTestError(null);
    setFaciliooContractTestResult(null);
    try {
      const result = await api.getFaciliooContractLive(contractId);
      setFaciliooContractTestResult(result);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Contract-Debug fehlgeschlagen";
      setFaciliooContractTestError(message);
    } finally {
      setFaciliooContractTestPending(false);
    }
  };

  const runFaciliooProcessDebug = async () => {
    const processRef = faciliooDebugProcessRef.trim();
    if (!processRef) {
      setFaciliooProcessTestError("Bitte eine Vorgangs-ID oder Vorgangsnummer eingeben.");
      setFaciliooProcessTestResult(null);
      return;
    }
    setFaciliooProcessTestPending(true);
    setFaciliooProcessTestError(null);
    setFaciliooProcessTestResult(null);
    try {
      const result = await api.resolveFaciliooProcess(processRef, {
        postFeedEntry: faciliooProcessFeedTestEnabled,
        feedText: faciliooProcessFeedTestEnabled ? faciliooProcessFeedTestText : undefined
      });
      setFaciliooProcessTestResult(result);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Vorgangs-Debug fehlgeschlagen";
      setFaciliooProcessTestError(message);
    } finally {
      setFaciliooProcessTestPending(false);
    }
  };

  const saveFaciliooControls = async (nextLiveSyncEnabled: boolean = faciliooLiveSyncEnabled) => {
    if (!uiSettings) return;
    setFaciliooControlPending(true);
    setFaciliooControlStatus(null);
    try {
      const payload: UiSettingsApi = {
        ...uiSettings,
        management: {
          ...uiSettings.management,
          faciliooLiveSyncEnabled: nextLiveSyncEnabled,
          faciliooLiveSyncIntervalMinutes: FACILIOO_LIVE_SYNC_INTERVAL_MINUTES
        }
      };
      await api.saveUiSettings(payload);
      await qc.invalidateQueries({ queryKey: ["ui-settings-facilioo-controls"] });
      setFaciliooControlStatus({ type: "ok", text: "Facilioo Live-Sync-Einstellungen gespeichert." });
      await refreshFaciliooSyncStatus();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Speichern fehlgeschlagen";
      setFaciliooControlStatus({ type: "error", text: message });
    } finally {
      setFaciliooControlPending(false);
    }
  };

  const saveDataConnectionMode = async (mode: "manual" | "facilioo") => {
    if (!uiSettings) return;
    const payload: UiSettingsApi = {
      ...uiSettings,
      management: {
        ...uiSettings.management,
        faciliooDataConnectionMode: mode
      }
    };
    // Optimistisch lokal anwenden, damit Sidebar/Reiter sofort reagieren.
    saveUiSettings(payload as unknown as UiSettings);
    window.dispatchEvent(new Event("ui-settings-updated"));
    try {
      await api.saveUiSettings(payload);
      await qc.invalidateQueries({ queryKey: ["ui-settings-facilioo-controls"] });
    } catch {
      // Bei Backend-Fehler bleibt der lokale Modus aktiv; erneuter Save beim nächsten Wechsel.
    }
  };

  const handleImportModeChange = (mode: "manual" | "facilioo") => {
    if (mode === "facilioo" && !faciliooEnabled) {
      return;
    }
    setImportMode(mode);
    if (mode === "facilioo" && manualImportType === "assignments") {
      setManualImportType("objects");
    }
    void saveDataConnectionMode(mode);
  };

  const handleFaciliooLiveSyncToggle = (enabled: boolean) => {
    setFaciliooLiveSyncEnabled(enabled);
    void saveFaciliooControls(enabled);
  };

  const runFaciliooMirrorCleanup = async (dryRun: boolean) => {
    setFaciliooMirrorCleanupPending(true);
    setFaciliooMirrorCleanupStatus(null);
    try {
      const result = await api.cleanupFaciliooMirrorUnits(dryRun);
      if (dryRun) {
        setFaciliooMirrorCleanupStatus({
          type: "ok",
          text: `Prüfung abgeschlossen. Geprüft: ${result.scanned}, Kandidaten: ${result.candidates}.`
        });
      } else {
        setFaciliooMirrorCleanupStatus({
          type: "ok",
          text: `Bereinigung abgeschlossen. Geprüft: ${result.scanned}, Gelöscht: ${result.deleted}.`
        });
      }
    } catch (error) {
      const message = error instanceof Error ? error.message : "Bereinigung fehlgeschlagen";
      setFaciliooMirrorCleanupStatus({ type: "error", text: message });
    } finally {
      setFaciliooMirrorCleanupPending(false);
    }
  };

  const getDatasetSyncState = (
    datasetKey: (typeof FACILIOO_DATASET_ORDER)[number]["key"]
  ): "idle" | "running" | "success" => {
    const webhookRun = faciliooSyncSnapshot?.webhookRun;
    if (webhookRun?.running && webhookRun.datasetKeys?.includes(datasetKey)) {
      return "running";
    }

    const currentRun = faciliooSyncSnapshot?.currentRun;
    const phase = currentRun?.phase;

    if (!faciliooSyncSnapshot?.running || !phase) {
      if (faciliooSyncSnapshot?.lastRun?.ok) return "success";
      return "idle";
    }

    if (phase === "objects_fetch" || phase === "objects_upsert") {
      return datasetKey === "objects" ? "running" : "idle";
    }
    if (phase === "units_fetch" || phase === "units_upsert") {
      if (datasetKey === "objects") return "success";
      return datasetKey === "units" ? "running" : "idle";
    }
    if (phase === "assignments_fetch" || phase === "assignments_upsert") {
      if (datasetKey === "objects" || datasetKey === "units") return "success";
      return datasetKey === "assignments" ? "running" : "idle";
    }
    if (phase === "owners_fetch" || phase === "owners_upsert") {
      if (datasetKey === "objects" || datasetKey === "units" || datasetKey === "assignments") return "success";
      return datasetKey === "owners" ? "running" : "idle";
    }
    if (phase === "cleanup") {
      return "success";
    }
    if (phase === "cancel_requested") {
      if (datasetKey === "objects" && (currentRun.objects?.processed ?? 0) > 0) return "success";
      if (datasetKey === "units" && (currentRun.units?.processed ?? 0) > 0) return "success";
      if (datasetKey === "assignments" && (currentRun.assignments?.processed ?? 0) > 0) return "success";
      if (datasetKey === "owners" && (currentRun.owners?.processed ?? 0) > 0) return "success";
      return "running";
    }
    if (phase === "cancelled") {
      if (datasetKey === "objects" && (currentRun.objects?.processed ?? 0) > 0) return "success";
      if (datasetKey === "units" && (currentRun.units?.processed ?? 0) > 0) return "success";
      if (datasetKey === "assignments" && (currentRun.assignments?.processed ?? 0) > 0) return "success";
      if (datasetKey === "owners" && (currentRun.owners?.processed ?? 0) > 0) return "success";
      return "idle";
    }
    if (phase === "done") {
      return "success";
    }
    if (phase === "error") {
      if (datasetKey === "objects" && currentRun.objects.processed > 0) return "success";
      if (datasetKey === "units" && currentRun.units.processed > 0) return "success";
      if (datasetKey === "assignments" && (currentRun.assignments?.processed ?? 0) > 0) return "success";
      if (datasetKey === "owners" && (currentRun.owners?.processed ?? 0) > 0) return "success";
      return "idle";
    }
    return "idle";
  };

  const getDatasetProgress = (datasetKey: (typeof FACILIOO_DATASET_ORDER)[number]["key"]) => {
    const webhookRun = faciliooSyncSnapshot?.webhookRun;
    if (webhookRun?.running && webhookRun.datasetKeys?.includes(datasetKey)) {
      if (datasetKey === "owners") {
        const processed = Number(webhookRun.processed ?? 0);
        const total = Number(webhookRun.total ?? 0);
        const percent = total > 0 ? Math.max(0, Math.min(100, Math.round((processed / total) * 100))) : 0;
        return { processed, total, percent, available: total > 0 };
      }
      return { processed: 0, total: 0, percent: 0, available: false };
    }

    const currentRun = faciliooSyncSnapshot?.currentRun;
    if (!currentRun) return { processed: 0, total: 0, percent: 0, available: false };
    const progress =
      datasetKey === "objects"
        ? currentRun.objects
        : datasetKey === "units"
          ? currentRun.units
          : datasetKey === "assignments"
            ? currentRun.assignments
            : currentRun.owners;
    const processed = Number(progress?.processed ?? 0);
    const total = Number(progress?.total ?? 0);
    const percent = total > 0 ? Math.max(0, Math.min(100, Math.round((processed / total) * 100))) : 0;
    return { processed, total, percent, available: total > 0 };
  };

  const lastRun = faciliooSyncSnapshot?.lastRun ?? null;
  const lastRunWasOk = Boolean(lastRun?.ok);
  const lastRunStatusLabel = lastRunWasOk ? "OK" : "Fehler";
  const lastRunAtLabel = formatDateTimeDE(lastRun?.finishedAt || lastRun?.startedAt);
  const lastRunDurationLabel = formatDurationLabel(lastRun?.durationMs);
  const lastSuccessfulSyncLabel = formatDateTimeDE(faciliooSyncSnapshot?.lastSuccessfulRun?.finishedAt);
  const latestSyncActor = String(latestFaciliooSyncLog?.data?.[0]?.actor_name ?? "").trim() || "-";
  const connectionLikelyHealthy =
    lastRunWasOk || (faciliooSyncSnapshot?.lastSuccessfulRun?.finishedAt ? true : false);
  const resolvedFaciliooApiEndpoint =
    String(uiSettings?.management?.faciliooApiKey ?? "").trim().length > 0 ? "https://api.facilioo.de" : "-";

  return (
    <div className={isFrameworkV2 ? "resolutions-v2-page imports-v2-page" : undefined}>
      <section className={`page-header panel ${isFrameworkV2 ? "resolutions-v2-page-header imports-v2-page-header" : ""}`}>
        <h2 className={isFrameworkV2 ? "resolutions-v2-title" : ""} style={{ margin: 0 }}>
          {isFrameworkV2 ? (
            <span className="resolutions-v2-title-icon" aria-hidden="true">
              {renderImportsMenuIcon()}
            </span>
          ) : null}
          {isFrameworkV2 ? (
            <span className="resolutions-v2-title-copy">
              <span className="resolutions-v2-title-main">Importe</span>
              <span className="resolutions-v2-title-sub">Datenabgleich und Facilioo-Synchronisierung</span>
            </span>
          ) : (
            <span>Importe</span>
          )}
        </h2>
        <div className={`imports-mode-toggle ${isFrameworkV2 ? "imports-mode-toggle--v2" : ""}`} role="tablist" aria-label="Datenabgleich-Modus">
          <button
            type="button"
            className={`${isFrameworkV2 ? "imports-v2-mode-button" : ""} ${importMode === "manual" ? "is-active" : ""}`.trim()}
            onClick={() => handleImportModeChange("manual")}
          >
            Manueller Datenabgleich
          </button>
          {faciliooEnabled ? (
            <button
              type="button"
              className={`${isFrameworkV2 ? "imports-v2-mode-button" : ""} ${importMode === "facilioo" ? "is-active" : ""}`.trim()}
              onClick={() => handleImportModeChange("facilioo")}
            >
              Facilioo Datenanbindung
            </button>
          ) : null}
        </div>
      </section>

      {importMode === "manual" ? (
      <section className="panel create-form imports-create-form">
        <h3 className={isFrameworkV2 ? "imports-manual-section-title" : undefined} style={{ marginTop: 0 }}>Manueller Datenabgleich</h3>
          <div className="imports-flow">
            <div className={`imports-type-toggle ${isFrameworkV2 ? "imports-manual-type-toggle-v2" : ""}`} role="tablist" aria-label="Importtyp (manuell)">
              {manualImportTypes.map((type) => (
                <button
                  key={type}
                  type="button"
                  disabled={importMode !== "manual"}
                  className={`${manualImportType === type ? "is-active" : ""} ${isFrameworkV2 ? "imports-manual-type-btn-v2" : ""}`.trim()}
                  onClick={() => {
                    setManualImportType(type);
                    initializeMapping(type);
                  }}
                >
                  {isFrameworkV2 ? <span className="imports-manual-type-icon-v2">{renderManualImportTypeIcon(type)}</span> : null}
                  {importLabel(type)}
                </button>
              ))}
            </div>
            <div className={`imports-sync-info-banner ${isFrameworkV2 ? "v2-info-banner imports-manual-intro-v2" : ""}`}>
              <span className="imports-sync-info-icon" aria-hidden="true">i</span>
              <div className="imports-sync-info-copy">
                <strong>Manueller Datenabgleich</strong>
                <span>Laden Sie Daten manuell über eine Excel- oder CSV-Datei hoch. Die Daten werden validiert und anschließend in das System übernommen.</span>
              </div>
            </div>
            <div className="form-grid">
              <div className={`form-field ${isFrameworkV2 ? "imports-manual-importtype-field-v2" : ""}`.trim()}>
                <label>Importtyp</label>
                <div className={isFrameworkV2 ? "imports-manual-select-v2" : undefined}>
                  {isFrameworkV2 ? <span className="imports-manual-select-icon-v2" aria-hidden="true">{renderManualImportTypeIcon(manualImportType)}</span> : null}
                  <input value={importLabel(manualImportType)} disabled />
                </div>
              </div>
              <div className="form-field">
                <label>Vorlage</label>
                <div className={isFrameworkV2 ? "imports-manual-template-row-v2" : undefined} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <button
                    type="button"
                    className={isFrameworkV2 ? "imports-manual-template-btn-v2" : undefined}
                    disabled={importMode !== "manual"}
                    onClick={async () => {
                      setActionError("");
                      try {
                        await api.downloadImportTemplate(manualImportType, "xlsx");
                      } catch (error) {
                        setActionError(error instanceof Error ? error.message : "Template-Download fehlgeschlagen");
                      }
                    }}
                  >
                    {isFrameworkV2 ? (
                      <span className="imports-manual-template-icon-v2 is-excel" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M7 4.2h7.4l2.6 2.6v12.8a1.8 1.8 0 0 1-1.8 1.8H7a1.8 1.8 0 0 1-1.8-1.8V6A1.8 1.8 0 0 1 7 4.2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                          <path d="M14.4 4.2v2.7h2.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="m8.3 10.2 3.8 5.1M12.1 10.2l-3.8 5.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                      </span>
                    ) : null}
                    Excel-Template (.xlsx)
                  </button>
                  <button
                    type="button"
                    className={isFrameworkV2 ? "imports-manual-template-btn-v2" : undefined}
                    disabled={importMode !== "manual"}
                    onClick={async () => {
                      setActionError("");
                      try {
                        await api.downloadImportTemplate(manualImportType, "csv");
                      } catch (error) {
                        setActionError(error instanceof Error ? error.message : "Template-Download fehlgeschlagen");
                      }
                    }}
                  >
                    {isFrameworkV2 ? (
                      <span className="imports-manual-template-icon-v2 is-csv" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M7 4.2h7.4l2.6 2.6v12.8a1.8 1.8 0 0 1-1.8 1.8H7a1.8 1.8 0 0 1-1.8-1.8V6A1.8 1.8 0 0 1 7 4.2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                          <path d="M14.4 4.2v2.7h2.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M8.2 10.3h5.8M8.2 13.1h5.8M8.2 15.9h5.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        </svg>
                      </span>
                    ) : null}
                    CSV-Template (.csv)
                  </button>
                </div>
              </div>
              <div className="form-field form-field-wide">
                <div className={isFrameworkV2 ? "imports-manual-file-wrap-v2" : undefined}>
                  {isFrameworkV2 ? (
                    <>
                      <input
                        id={manualFileInputId}
                        ref={manualFileInputRef}
                        className="imports-manual-file-input-v2"
                        type="file"
                        accept=".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                        disabled={importMode !== "manual"}
                        onChange={(e) => handleManualFileSelect(e.target.files)}
                      />
                    </>
                  ) : (
                    <input
                      type="file"
                      accept=".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                      disabled={importMode !== "manual"}
                      onChange={(e) => handleManualFileSelect(e.target.files)}
                    />
                  )}
                </div>
                <div
                  className={`${isFrameworkV2 ? "imports-manual-dropzone-v2" : "panel-inset"} ${manualFileDragActive ? "is-drag-active" : ""}`.trim()}
                  role="button"
                  tabIndex={importMode !== "manual" ? -1 : 0}
                  aria-disabled={importMode !== "manual"}
                  onClick={() => {
                    if (importMode !== "manual") return;
                    manualFileInputRef.current?.click();
                  }}
                  onKeyDown={(e) => {
                    if (importMode !== "manual") return;
                    if (e.key !== "Enter" && e.key !== " ") return;
                    e.preventDefault();
                    manualFileInputRef.current?.click();
                  }}
                  onDragOver={(e) => {
                    if (importMode !== "manual") return;
                    e.preventDefault();
                    setManualFileDragActive(true);
                  }}
                  onDragLeave={(e) => {
                    if (importMode !== "manual") return;
                    e.preventDefault();
                    setManualFileDragActive(false);
                  }}
                  onDrop={(e) => {
                    if (importMode !== "manual") return;
                    e.preventDefault();
                    setManualFileDragActive(false);
                    handleManualFileSelect(e.dataTransfer?.files);
                  }}
                >
                  {isFrameworkV2 ? (
                    <>
                      <span className="imports-manual-dropzone-icon-v2" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M12 15.8V6.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                          <path d="m8.4 10.2 3.6-3.6 3.6 3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                          <rect x="5" y="16.2" width="14" height="2.8" rx="1.1" stroke="currentColor" strokeWidth="1.8" />
                        </svg>
                      </span>
                      <span className="imports-manual-dropzone-copy-v2">
                        <span className="imports-manual-dropzone-title-v2">Datei hierhin ziehen und ablegen</span>
                      <span className="imports-manual-dropzone-sub-v2">oder klicken, um eine Datei auszuwählen (.csv, .xls, .xlsx)</span>
                    </span>
                  </>
                ) : (
                  <span>Datei hier ablegen oder klicken zum Auswählen.</span>
                )}
              </div>
              {isFrameworkV2 ? (
                <div className="imports-manual-selected-file-v2">
                  <span className="imports-manual-selected-file-label-v2">Ausgewählte Datei</span>
                  <span className="imports-manual-file-name-v2">{file?.name ?? "Keine ausgewählt"}</span>
                </div>
              ) : null}
            </div>
            </div>
            <div className={isFrameworkV2 ? "imports-manual-notes-v2" : "panel-inset"}>
              {isFrameworkV2 ? (
                <div className="imports-manual-notes-head-v2">
                  <span className="imports-sync-info-icon" aria-hidden="true">i</span>
                  <strong>Hinweise</strong>
                </div>
              ) : (
                <strong>Hinweise</strong>
              )}
              <ul className="imports-manual-notes-list-v2">
                <li>Erlaubte Dateiformate: .xlsx, .xls, .csv</li>
                <li>Maximale Dateigröße: 25 MB</li>
                <li>Die erste Zeile der Datei muss Überschriften enthalten.</li>
                <li>Bestehende Datensätze werden anhand der eindeutigen Schlüssel aktualisiert.</li>
              </ul>
            </div>

            <div className={`form-actions ${isFrameworkV2 ? "imports-manual-upload-row-v2" : ""}`}>
              <button className={isFrameworkV2 ? "imports-manual-upload-btn-v2" : undefined} disabled={importMode !== "manual" || !canUpload} onClick={() => uploadMutation.mutate()}>
                {isFrameworkV2 ? (
                  <span className="imports-manual-upload-btn-icon-v2" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M12 15.8V6.8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="m8.4 10.2 3.6-3.6 3.6 3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <rect x="5" y="16.2" width="14" height="2.8" rx="1.1" stroke="currentColor" strokeWidth="1.8" />
                    </svg>
                  </span>
                ) : null}
                {uploadMutation.isPending ? "Lade hoch..." : "Upload starten"}
              </button>
              {isFrameworkV2 && (importMode !== "manual" || !file) ? (
                <small className="imports-manual-upload-hint-v2">Bitte wählen Sie zuerst eine Datei aus.</small>
              ) : null}
            </div>

            {job ? (
              <>
                {isFrameworkV2 ? (
                  <>
                    <div className="imports-v2-job-card panel-inset">
                      <div className="imports-v2-job-main">
                        <div className="imports-v2-job-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M6.1 3.9h7l4.8 4.8v10.2a1.8 1.8 0 0 1-1.8 1.8H6.1a1.8 1.8 0 0 1-1.8-1.8V5.7a1.8 1.8 0 0 1 1.8-1.8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                            <path d="M13.1 3.9v4.9H18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M8.1 11.1h6.2M8.1 14.2h6.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                          </svg>
                        </div>
                        <div className="imports-v2-job-copy">
                          <h4>Aktueller Job</h4>
                          <div className="imports-v2-job-line">
                            <span>{importLabel(job.import_typ)}</span>
                            <span className="imports-v2-job-dot">•</span>
                            <span>Datei: {job.filename}</span>
                            <span className="imports-v2-job-dot">•</span>
                            <span>Status:</span>
                            <span className="imports-v2-job-status-pill">{statusLabel(job.status)}</span>
                          </div>
                          <div className="imports-v2-job-stats">
                            <span className="imports-v2-job-stat is-total">
                              <span className="imports-v2-job-stat-icon" aria-hidden="true">✓</span>
                              Gesamt: {job.total_rows ?? 0}
                            </span>
                            <span className="imports-v2-job-stat is-valid">
                              <span className="imports-v2-job-stat-icon" aria-hidden="true">i</span>
                              Valide: {job.valid_rows ?? 0}
                            </span>
                            <span className="imports-v2-job-stat is-error">
                              <span className="imports-v2-job-stat-icon" aria-hidden="true">!</span>
                              Fehler: {job.invalid_rows ?? 0}
                            </span>
                          </div>
                        </div>
                      </div>
                      <button type="button" className="imports-v2-job-download-btn" onClick={handleDownloadManualFile} disabled={!file}>
                        <span className="imports-v2-job-download-icon" aria-hidden="true">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M12 4.6v9.1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            <path d="m8.1 9.8 3.9 3.9 3.9-3.9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M5.5 18.3h13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                          </svg>
                        </span>
                        Datei herunterladen
                      </button>
                    </div>

                    <div className="imports-v2-mapping-card panel-inset">
                      <h4 className="imports-v2-mapping-title">
                        <span className="imports-v2-mapping-step-bullet" aria-hidden="true">2</span>
                        <span>Spaltenmapping</span>
                      </h4>
                      <div className="imports-v2-mapping-intro v2-info-banner">
                        <span className="imports-sync-info-icon" aria-hidden="true">i</span>
                        <span className="imports-v2-mapping-intro-copy">
                          Ordnen Sie die Spalten Ihrer Datei den passenden Feldern im System zu. Pflichtfelder sind erforderlich für einen erfolgreichen Import.
                        </span>
                      </div>
                      <div className="imports-v2-mapping-grid">
                        {requiredFields.map((field) => (
                          <div key={field} className="imports-v2-mapping-field">
                            <label>
                              {importFieldLabel(field)} <span className="imports-v2-required-star">*</span>
                            </label>
                            <div className="imports-v2-mapping-select-wrap">
                              <select
                                value={mappingOptions.includes(String(mapping[field] ?? "")) ? String(mapping[field] ?? "") : ""}
                                onChange={(e) => {
                                  setValidationFeedback(null);
                                  setMapping((prev) => ({ ...prev, [field]: e.target.value }));
                                }}
                              >
                                <option value="">Spalte auswählen</option>
                                {mappingOptions.map((option) => (
                                  <option key={`${field}-${option}`} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                              <span className="imports-v2-mapping-select-chevron" aria-hidden="true">
                                <svg viewBox="0 0 16 16" fill="none">
                                  <path d="m4 6 4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    <div className="imports-v2-mapping-actions">
                        <button className="imports-v2-mapping-validate-btn" disabled={!canValidate} onClick={() => validateMutation.mutate()}>
                          <span className="imports-v2-mapping-action-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none">
                              <circle cx="11.2" cy="11.2" r="6.6" stroke="currentColor" strokeWidth="1.8" />
                              <path d="m16.2 16.2 3.3 3.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            </svg>
                          </span>
                          {validateMutation.isPending ? "Validiere..." : "Validieren"}
                        </button>
                        <button className="imports-v2-mapping-commit-btn" disabled={!canCommit} onClick={() => commitMutation.mutate()}>
                          <span className="imports-v2-mapping-action-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M8.1 6.7 17 12l-8.9 5.3V6.7Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                            </svg>
                          </span>
                          {commitMutation.isPending ? "Importiere..." : "Import final ausführen"}
                        </button>
                        {validationFeedback ? (
                          <span
                            className={`imports-v2-mapping-feedback-inline ${validationFeedback.type === "error" ? "is-error" : validationFeedback.type === "warn" ? "is-warn" : "is-success"}`}
                            role="status"
                            aria-live="polite"
                          >
                            {validationFeedback.text}
                          </span>
                        ) : hasMappingConflict ? (
                          <span className="imports-v2-mapping-feedback-inline is-warn" role="status" aria-live="polite">
                            {mappingConflictText}
                          </span>
                        ) : null}
                      </div>
                      <div className="imports-v2-mapping-hint">
                        <span className="imports-v2-mapping-hint-icon" aria-hidden="true">i</span>
                        <div>
                          <strong>Hinweis</strong>
                          <p>Sie können die Spaltenzuordnung vor der Validierung jederzeit anpassen. Nach der Validierung sehen Sie eine Vorschau der Daten sowie etwaige Fehler.</p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="panel-inset imports-job-summary">
                      <strong>Aktueller Job:</strong> {importLabel(job.import_typ)} | Datei: {job.filename} | Status:{" "}
                      <span className={statusBadgeClass(job.status)}>{statusLabel(job.status)}</span>
                      {validationSummary ? <div style={{ marginTop: 6, color: "var(--text-soft)" }}>{validationSummary}</div> : null}
                    </div>

                    <div className="imports-mapping-block">
                      <h4 style={{ marginBottom: 8 }}>2) Spaltenmapping</h4>
                      <div className="imports-mapping-grid">
                        {requiredFields.map((field) => (
                          <div key={field} className="form-field">
                            <label>{field}</label>
                            <input
                              value={mapping[field] ?? field}
                              onChange={(e) => {
                                setValidationFeedback(null);
                                setMapping((prev) => ({ ...prev, [field]: e.target.value }));
                              }}
                              placeholder={`Quellspalte für ${field}`}
                            />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="form-actions">
                      <button disabled={!canValidate} onClick={() => validateMutation.mutate()}>
                        {validateMutation.isPending ? "Validiere..." : "Validieren"}
                      </button>
                      <button disabled={!canCommit} onClick={() => commitMutation.mutate()}>
                        {commitMutation.isPending ? "Importiere..." : "Import final ausführen"}
                      </button>
                    </div>
                  </>
                )}

                {pendingWarningConfirmations.length ? (
                  <small style={{ color: "#b54708", fontWeight: 600 }}>
                    Bitte bestätige alle überschreibbaren Meldungen, damit der Import fortgesetzt werden kann.
                  </small>
                ) : null}

                {validationErrors.length ? (
                  <div className={`panel-inset imports-validation-errors${isFrameworkV2 ? " imports-v2-errors-card" : ""}`}>
                    <h4 className={isFrameworkV2 ? "imports-v2-errors-title" : undefined} style={{ marginTop: 0 }}>Fehlerliste</h4>
                    <table className="imports-validation-errors-table">
                      <thead>
                        <tr>
                          <th>Zeile</th>
                          <th>Feld</th>
                          <th>Code</th>
                          <th>Typ</th>
                          <th>Bestätigung</th>
                          <th>Meldung</th>
                        </tr>
                      </thead>
                      <tbody>
                        {validationErrors.map((error, index) => (
                          <tr key={`${error.rowNumber}-${error.field}-${index}`}>
                            <td>{error.rowNumber}</td>
                            <td>{error.field}</td>
                            <td>
                              {isFrameworkV2 ? (
                                <span className="imports-v2-errors-code-badge">{error.code}</span>
                              ) : (
                                error.code
                              )}
                            </td>
                            <td>
                              {isFrameworkV2 ? (
                                <span className={`imports-v2-errors-type-badge ${error.overridable ? "is-warn" : "is-error"}`}>
                                  {error.overridable ? "Warnung" : "Fehler"}
                                </span>
                              ) : (
                                error.overridable ? "Warnung" : "Fehler"
                              )}
                            </td>
                            <td>
                              {error.overridable ? (
                                <label className={isFrameworkV2 ? "imports-v2-errors-confirm-label" : undefined} style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                  <input
                                    type="checkbox"
                                    checked={Boolean(confirmedWarnings[error.id])}
                                    onChange={(e) =>
                                      setConfirmedWarnings((prev) => ({
                                        ...prev,
                                        [error.id]: e.target.checked
                                      }))
                                    }
                                  />
                                  Überschreiben
                                </label>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{error.message}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </>
            ) : null}

            {actionError ? <div className={isFrameworkV2 ? "imports-v2-feedback-error" : "error-text"}>{actionError}</div> : null}
          </div>
      </section>
      ) : null}

      {faciliooEnabled && importMode === "facilioo" ? (
      <>
      <section className="panel create-form imports-create-form">
        <h3 className="imports-facilioo-section-title" style={{ marginTop: 0 }}>Facilioo-Import</h3>
        <div className="imports-flow">
          <div className="panel-inset imports-sync-visual-card">
            <div className="imports-sync-visual-header">
              <div className="imports-sync-visual-meta">
                <strong>{faciliooSyncRunning ? "Facilioo-Synchronisierung läuft" : "Facilioo-Synchronisierung"}</strong>
                <small className="imports-sync-last-run-line">
                  Letzter Lauf:{" "}
                  <span className={`imports-v2-badge ${lastRunWasOk ? "is-ok" : "is-error"}`}>{lastRunStatusLabel}</span>{" "}
                  | {lastRunAtLabel} | Dauer: {lastRunDurationLabel}
                </small>
                {faciliooSyncSnapshot?.currentRun?.message && faciliooSyncSnapshot?.running ? (
                  <small className="imports-sync-running-text">{faciliooSyncSnapshot.currentRun.message}</small>
                ) : null}
                {faciliooSyncSnapshot?.webhookRun ? (
                  <small className="imports-sync-running-text imports-sync-running-text--webhook">
                    {faciliooSyncSnapshot.webhookRun.running
                      ? `Webhook-Sync läuft (${(faciliooSyncSnapshot.webhookRun.entityNames ?? []).join(", ") || "-"}), Start: ${formatDateTimeDE(
                          faciliooSyncSnapshot.webhookRun.startedAt
                        )}`
                      : `Letzter Webhook-Sync: ${formatDateTimeDE(
                          faciliooSyncSnapshot.webhookRun.finishedAt || faciliooSyncSnapshot.webhookRun.startedAt
                        )} | Dauer: ${formatDurationLabel(faciliooSyncSnapshot.webhookRun.durationMs)}${
                          faciliooSyncSnapshot.webhookRun.message
                            ? ` | ${faciliooSyncSnapshot.webhookRun.message}`
                            : ""
                        }`}
                  </small>
                ) : null}
              </div>
              <div className="imports-sync-header-live-toggle">
                <span className="imports-sync-header-live-label">Live-Sync</span>
                <label
                  className="result-visibility-switch imports-facilioo-switch"
                  aria-label="Facilioo Live-Sync umschalten"
                  title={`Live-Sync-Fallback laeuft ${FACILIOO_LIVE_SYNC_SCHEDULE_LABEL}.`}
                >
                  <input
                    className="result-visibility-input"
                    type="checkbox"
                    checked={faciliooLiveSyncEnabled}
                    disabled={importMode !== "facilioo" || !uiSettings || faciliooControlPending}
                    onChange={(e) => handleFaciliooLiveSyncToggle(e.target.checked)}
                  />
                  <span className={`result-visibility-track ${faciliooLiveSyncEnabled ? "is-on" : ""}`}>
                    <span className="result-visibility-thumb" />
                  </span>
                  <span className="result-visibility-state">{faciliooLiveSyncEnabled ? "Aktiv" : "Inaktiv"}</span>
                </label>
                <span
                  className="imports-sync-tooltip-hint"
                  title={`Live-Sync-Fallback laeuft ${FACILIOO_LIVE_SYNC_SCHEDULE_LABEL}.`}
                  aria-label="Intervall-Hinweis"
                >
                  i
                </span>
              </div>
            </div>
            <div className="imports-sync-dataset-grid">
              {FACILIOO_DATASET_ORDER.map((dataset) => {
                const stats = faciliooSyncSnapshot?.lastRun?.datasets?.[dataset.key];
                const syncState = getDatasetSyncState(dataset.key);
                const progress = getDatasetProgress(dataset.key);
                return (
                  <div
                    key={dataset.key}
                    className={`imports-sync-dataset-card ${dataset.className} ${syncState === "running" ? "is-active" : ""}`}
                  >
                    <div className="imports-sync-dataset-card-header">
                      <div className="imports-sync-dataset-title">{dataset.label}</div>
                      <span
                        className={`imports-sync-dataset-gear ${syncState === "running" ? "is-running" : ""} ${syncState === "success" ? "is-success" : ""}`}
                        aria-hidden="true"
                        title={
                          syncState === "running"
                            ? `${dataset.label} wird synchronisiert`
                            : syncState === "success"
                              ? `${dataset.label} erfolgreich abgeschlossen`
                              : `${dataset.label} wartet`
                        }
                      >
                        <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                          <g fill="currentColor">
                            <circle cx="12" cy="12" r="5.4" />
                            <circle cx="12" cy="12" r="2.3" fill="#ffffff" />
                            <rect x="11.2" y="1.2" width="1.6" height="3.2" rx="0.5" />
                            <rect x="11.2" y="19.6" width="1.6" height="3.2" rx="0.5" />
                            <rect x="19.6" y="11.2" width="3.2" height="1.6" rx="0.5" />
                            <rect x="1.2" y="11.2" width="3.2" height="1.6" rx="0.5" />
                            <rect x="11.2" y="1.2" width="1.6" height="3.2" rx="0.5" transform="rotate(45 12 12)" />
                            <rect x="11.2" y="1.2" width="1.6" height="3.2" rx="0.5" transform="rotate(135 12 12)" />
                            <rect x="11.2" y="1.2" width="1.6" height="3.2" rx="0.5" transform="rotate(225 12 12)" />
                            <rect x="11.2" y="1.2" width="1.6" height="3.2" rx="0.5" transform="rotate(315 12 12)" />
                          </g>
                        </svg>
                      </span>
                    </div>
                    <div className="imports-sync-dataset-body">
                      <div className={`imports-sync-dataset-avatar ${dataset.className}`} aria-hidden="true">
                        {renderDatasetSymbol(dataset.key)}
                      </div>
                      <div className="imports-sync-dataset-stats">
                        <span>Geholt: {stats?.fetched ?? 0}</span>
                        <span>Neu: {stats?.created ?? 0}</span>
                        <span>Aktualisiert: {stats?.updated ?? 0}</span>
                        <span>Unverändert: {stats?.unchanged ?? 0}</span>
                      </div>
                    </div>
                    <div className="imports-sync-dataset-footer">
                      {faciliooSyncRunning ? (
                        progress.available ? (
                          <div className="imports-sync-progress-wrap">
                            <small className="imports-sync-progress-text">
                              Fortschritt: {progress.processed}/{progress.total} ({progress.percent}%)
                            </small>
                            <div className="imports-sync-progress-bar" aria-hidden="true">
                              <span style={{ width: `${progress.percent}%` }} />
                            </div>
                          </div>
                        ) : (
                          <small className="imports-sync-progress-text">
                            {syncState === "running" ? "Wird aktuell verarbeitet..." : "Wird im nächsten Schritt verarbeitet..."}
                          </small>
                        )
                      ) : (
                        <small className="imports-sync-progress-text">-</small>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="imports-sync-info-banner v2-info-banner">
              <span className="imports-sync-info-icon" aria-hidden="true">i</span>
              <div className="imports-sync-info-copy">
                <span>Die Synchronisierung mit Facilioo läuft. Je nach Datenmenge kann der Vorgang mehrere Minuten dauern.</span>
                <span>Sie können diese Seite verlassen - die Synchronisierung läuft im Hintergrund weiter.</span>
              </div>
            </div>
            <div className="imports-sync-controls-row">
              <div className="form-actions imports-facilioo-actions-row imports-facilioo-actions-row--bottom">
                <button
                  className="imports-sync-cta-button is-outline has-right-icon"
                  disabled={importMode !== "facilioo" || faciliooTestPending}
                  onClick={runFaciliooTest}
                >
                  <span className="imports-sync-cta-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M20 12a8 8 0 1 1-2.34-5.66" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M20 4v4h-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="imports-sync-cta-label">{faciliooTestPending ? "Facilioo-Test läuft..." : "Facilioo-Verbindung testen"}</span>
                  <span className="imports-sync-cta-icon imports-sync-cta-icon-right" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M14 5h5v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M19 5 10 14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M10 5H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                  </span>
                </button>
                <button
                  className="imports-sync-cta-button is-primary is-sync-green has-right-icon"
                  disabled={importMode !== "facilioo" || faciliooSyncPending || faciliooSyncRunning}
                  onClick={runFaciliooLiveUpdateNow}
                >
                  <span className="imports-sync-cta-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M20 12a8 8 0 1 1-2.34-5.66" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M20 4v4h-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="imports-sync-cta-label">{faciliooSyncRunning ? "Synchronisierung läuft..." : faciliooSyncPending ? "Live-Update startet..." : "Live-Update"}</span>
                  <span className="imports-sync-cta-icon imports-sync-cta-icon-right" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <g fill="currentColor">
                        <circle cx="12" cy="12" r="4.6" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" />
                        <rect x="11.15" y="19.1" width="1.7" height="3.1" rx="0.5" />
                        <rect x="19.1" y="11.15" width="3.1" height="1.7" rx="0.5" />
                        <rect x="1.8" y="11.15" width="3.1" height="1.7" rx="0.5" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(45 12 12)" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(135 12 12)" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(225 12 12)" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(315 12 12)" />
                      </g>
                      <circle cx="12" cy="12" r="1.7" fill="#ffffff" />
                    </svg>
                  </span>
                </button>
                <button
                  className="imports-sync-cta-button is-primary is-sync-green has-right-icon"
                  disabled={importMode !== "facilioo" || faciliooSyncPending || faciliooSyncRunning}
                  onClick={runFaciliooFullSyncNow}
                >
                  <span className="imports-sync-cta-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M20 12a8 8 0 1 1-2.34-5.66" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      <path d="M20 4v4h-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <span className="imports-sync-cta-label">{faciliooSyncRunning ? "Synchronisierung läuft..." : faciliooSyncPending ? "Voll-Sync startet..." : "Voll-Sync"}</span>
                  <span className="imports-sync-cta-icon imports-sync-cta-icon-right" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <g fill="currentColor">
                        <circle cx="12" cy="12" r="4.6" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" />
                        <rect x="11.15" y="19.1" width="1.7" height="3.1" rx="0.5" />
                        <rect x="19.1" y="11.15" width="3.1" height="1.7" rx="0.5" />
                        <rect x="1.8" y="11.15" width="3.1" height="1.7" rx="0.5" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(45 12 12)" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(135 12 12)" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(225 12 12)" />
                        <rect x="11.15" y="1.8" width="1.7" height="3.1" rx="0.5" transform="rotate(315 12 12)" />
                      </g>
                      <circle cx="12" cy="12" r="1.7" fill="#ffffff" />
                    </svg>
                  </span>
                </button>
                <button
                  className="imports-sync-cta-button is-danger"
                  disabled={importMode !== "facilioo" || !faciliooSyncRunning || faciliooSyncCancelPending}
                  onClick={cancelFaciliooSyncNow}
                >
                  <span className="imports-sync-cta-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="1.8" />
                      <path d="M8.6 15.4 15.4 8.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                  </span>
                  <span className="imports-sync-cta-label">{faciliooSyncCancelPending ? "Abbruch wird angefordert..." : "Sync abbrechen"}</span>
                </button>
              </div>
            </div>
          </div>
          {faciliooTestStatus && faciliooTestStatus.type === "error" ? (
            <small style={{ color: "#b42318", fontWeight: 600 }}>
              {faciliooTestStatus.text}
            </small>
          ) : null}
          {faciliooSyncStatusMessage && faciliooSyncStatusMessage.type === "error" ? (
            <small
              style={{
                color: "#b42318",
                fontWeight: 600
              }}
            >
              {faciliooSyncStatusMessage.text}
            </small>
          ) : null}
          {faciliooControlStatus && faciliooControlStatus.type === "error" ? (
            <small style={{ color: "#b42318", fontWeight: 600 }}>
              {faciliooControlStatus.text}
            </small>
          ) : null}
          {faciliooMirrorCleanupStatus && faciliooMirrorCleanupStatus.type === "error" ? (
            <small style={{ color: "#b42318", fontWeight: 600 }}>
              {faciliooMirrorCleanupStatus.text}
            </small>
          ) : null}

        </div>
      </section>
      <div className="imports-sync-connection-kpi">
        <div className="imports-sync-connection-kpi-header">
          <strong>Facilioo-Verbindungsdetails</strong>
          <span className="imports-sync-connection-kpi-chevron" aria-hidden="true">
            <svg viewBox="0 0 20 20" fill="none">
              <path d="m6 8 4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
        <div className="imports-sync-connection-kpi-grid">
          <div className="imports-sync-connection-kpi-item">
            <small>Verbindungsstatus</small>
            <span className={`imports-v2-badge ${connectionLikelyHealthy ? "is-ok" : "is-error"}`}>
              {connectionLikelyHealthy ? "Verbunden" : "Prüfen"}
            </span>
          </div>
          <div className="imports-sync-connection-kpi-item">
            <small>Letzter erfolgreicher Sync</small>
            <strong>{lastSuccessfulSyncLabel}</strong>
          </div>
          <div className="imports-sync-connection-kpi-item">
            <small>API-Endpunkt</small>
            <strong>{resolvedFaciliooApiEndpoint}</strong>
          </div>
          <div className="imports-sync-connection-kpi-item">
            <small>Zuletzt synchronisiert von</small>
            <strong>{latestSyncActor}</strong>
          </div>
        </div>
      </div>
      </>
      ) : null}

    </div>
  );
};


